/** @format */


import {AxiosInstance} from "../../../utils/AxiosInstance";
import { environment } from "../../../env";

const axiosInstance = (new AxiosInstance(`${environment.API}/`, 'userList')).getAxiosInstance()

const SERVICE = {
  getUserStatuses: () => axiosInstance.get("userStatuses"),
};

export default SERVICE;
